import { Table, TableItem, TableRow, Tag, Typography } from '@components';
import { RmmState } from '@interfaces';
import { ListComponent } from '@utils';
import React from 'react';

type RowItem = {
  key: string;
  entityId: string;
  type: 'host' | 'vm';
  name: string;
  hostName?: string;
  serial?: string;
  state?: string;
  rmm?: RmmState;
};

interface Props {
  rows: RowItem[];
  onRowClick?: (entityId: string) => void;
}

const tableHeaders: string[] = [
  'type',
  'Naam',
  'Host',
  'Serial',
  'State',
  'RMM',
];

export function ServerParkListView({ rows, onRowClick }: Props) {
  const getStatusColor = (rmm?: RmmState) => {
    if (!rmm?.present) return 'bg-slate-400';

    switch (rmm.status) {
      case 'online':
        return 'bg-emerald-400';
      case 'warning':
        return 'bg-amber-400';
      case 'offline':
        return 'bg-red-400';
      default:
        return 'bg-slate-400';
    }
  };

  const tagStyle = {
    Running: 'online',
    Off: 'danger',
  };

  return (
    <div className="w-full h-full overflow-auto">
      <Table header={tableHeaders}>
        <ListComponent
          data={rows}
          renderItem={(row) => (
            <TableRow key={row.key} onClick={() => onRowClick?.(row.entityId)}>
              <TableItem>
                {row.type === 'host' ? (
                  <Typography tag="span" type="labelSemiBold" color="blue">
                    Host
                  </Typography>
                ) : (
                  'VM'
                )}
              </TableItem>

              <TableItem>
                {row.type === 'vm' && (
                  <span className="text-slate-400 mr-1">↳</span>
                )}
                {row.name}
              </TableItem>

              <TableItem>{row.type === 'vm' ? row.hostName : '-'}</TableItem>

              <TableItem>{row.serial ?? '-'}</TableItem>

              <TableItem>
                {row.state ? (
                  <Tag
                    label={row.state}
                    style={tagStyle[row.state]}
                    lowercase
                  />
                ) : (
                  '-'
                )}
              </TableItem>

              <TableItem>
                <div className="flex items-center gap-2">
                  <div
                    className={`w-2.5 h-2.5 rounded-full ${getStatusColor(row.rmm)}`}
                  />
                  <span className="text-xs text-slate-500">
                    {row.rmm?.status ?? 'unknown'}
                  </span>
                </div>
              </TableItem>
            </TableRow>
          )}
        />
      </Table>

      {rows.length === 0 && (
        <tr>
          <td colSpan={6} className="p-6 text-center text-slate-400">
            No results
          </td>
        </tr>
      )}
    </div>
  );
}

export default ServerParkListView;
